module.exports = __webpack_public_path__ + "lx.png?d3d4a32496cbbad8e7b6136aeb63ea1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lx.png
// module id = 83
// module chunks = 0